module.exports = __webpack_public_path__ + "static/img/info3.98cf8fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/info3.png
// module id = J05N
// module chunks = 18